import React, { useEffect } from 'react';

const CustomSection = ({ section }) => {
  const sectionData = section.section_data || {};
  const html = sectionData.html || section.content || '';
  const css = sectionData.css || '';
  const js = sectionData.js || '';

  useEffect(() => {
    // Inject custom CSS
    if (css) {
      const styleId = `custom-section-${section.id}-css`;
      let styleElement = document.getElementById(styleId);
      if (!styleElement) {
        styleElement = document.createElement('style');
        styleElement.id = styleId;
        document.head.appendChild(styleElement);
      }
      styleElement.textContent = css;
    }

    // Execute custom JavaScript
    if (js) {
      try {
        // Use Function constructor to execute in isolated scope
        const func = new Function(js);
        func();
      } catch (error) {
        console.error('Error executing custom section JavaScript:', error);
      }
    }

    // Cleanup
    return () => {
      if (css) {
        const styleElement = document.getElementById(`custom-section-${section.id}-css`);
        if (styleElement) {
          styleElement.remove();
        }
      }
    };
  }, [css, js, section.id]);

  if (!html) {
    return null;
  }

  return (
    <section
      className="custom-section"
      style={{
        backgroundColor: section.background_color || '#ffffff',
        color: section.text_color || '#000000',
        padding: '40px 20px'
      }}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
};

export default CustomSection;
